var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 h-100",attrs:{"id":"app"}},[(_vm.$route.meta.requiresHeader)?_c('app-header'):_vm._e(),_c('router-view'),(_vm.$route.meta.requireFooter)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }